module.exports = __webpack_public_path__ + "img/doorLogo25.b9c97bab.png";